import { toastError } from '../customs/Toast/Toast'

const ERR_IEN_TYPE_MSG: any = {
  'ERR001': 'Neplatný požadavek.',
  'ERR002': 'Neautorizovaný požadavek.',
  'ERR003': 'Entita neexistuje.',
  'ERR004': 'Uživatel nemá požadovaná oprávnění pro danou entitu.',
  'ERR005': 'Interní chyba aplikace.',
  'ERR006': 'Chyba při komunikaci s CDD.',
}

export const errorIenProces = (e: any) => {

  const response = e?.response
  const { popisChyby, kodChyby } = response?.data || {}

  if (popisChyby || kodChyby) {
    const kodChybyMsg = ERR_IEN_TYPE_MSG[kodChyby]
    return popisChyby ? `${popisChyby} ${kodChybyMsg ? `(${kodChybyMsg})` : ''}` : kodChybyMsg
  }
  
  if (!response?.status || response?.status >= 500) {
    return 'Elektronický nástroj neodpovídá.'
  }

  return e.toString()
}

export const errorIenProcesToast = (e: any) => {
  toastError(errorIenProces(e))
}
export const errorIenProcesThrow = (e: any) => {
  throw errorIenProces(e)
}
